<template>
	<div id="app" style="background-color: #F5F5F5;color: #000;font-weight: 900;height: 100vh;">
		<canvas id="cvs1" style="display: none;"></canvas>
		<div style="padding: 10px;border-bottom: 1px solid #000;font-size: 28px;">
			<span v-if="sta==0">Fitting前数据测量</span><span v-if="sta==0" style="font-size: 18px;margin-left:20px;">调整数据前，踩踏一段，然后保存为Fitting前参数</span>
			<span v-if="sta==1">动态Fitting中</span><span v-if="sta==1" style="font-size: 18px;margin-left:20px;">调整完毕后，保存参数并完成动态评估</span>
			<span v-if="call!=''" style="color: #00B83F;font-size: 18px;">
				{{call}}
			</span>
			<span v-else style="color: #00B83F;font-size: 18px;">
				为保障测量精确，请穿短袖短裤骑行服和锁鞋。
			</span>


		</div>
		<div style="display: flex;margin-left: 20px;padding-top:10px;">

			<div style="flex: 2;width: 200px;text-align: center;">
				<div style="display: flex;justify-content: center;font-size: 16px;">
					<div>
						<div style="text-align: center">
							髋关节稳定性
						</div>
						<div style="width: 166px;height: 166px;background: #000;margin-top: 10px;">
							<canvas id="cvs6"></canvas>
						</div>
					</div>

				</div>
				<div style="display: flex;justify-content: center;margin-top: 10px;">
					<div>
						<div style="text-align: center">
							踝关节稳定性
						</div>
						<div style="width: 166px;height: 166px;background: #000;margin-top: 10px;">
							<canvas id="cvs2"></canvas>
						</div>
					</div>

				</div>
				<div style="display: flex;justify-content: center;margin-top: 10px;">
					<div>
						<div style="text-align: center">
							膝关节踏稳定性
						</div>
						<div style="width: 166px;height: 166px;background: #000;margin-top: 10px;">
							<canvas id="cvs3"></canvas>
						</div>
					</div>
				</div>
				<div>
					<button @click="wd_clean" class="btn btn-primary" style="margin-top: 20px;">稳定性重置</button>
				</div>
			</div>
			<div style="flex: 2;padding: 10px 20px;font-size: 16px;max-width: 400px;">
				<div v-for="(item, index) in dat" style="padding: 5px;" :key="index">
					<div style="display: flex">
						<div style="width: 160px;">{{item.name}}</div>
						<div v-if="item.color=='green'" style="margin: 0 20px;color: #00B83F;width: 60px;">{{item.val}}</div>
						<div v-if="item.color=='yellow'" style="margin: 0 20px;color: #ece864;width: 60px;">{{item.val}}</div>
						<div v-if="item.color=='red'" style="margin: 0 20px;color: #b41a3f;width: 60px;">{{item.val}}</div>
					</div>
				</div>
			</div>

			<div style="flex: 5;display: flex;justify-content: center;">
				<div>

					<div style="width: 500px; height: 500px; background: #000; display: flex; justify-content: center; align-items: center; position: relative;">
						<canvas id="cvs5" style="position: absolute;z-index: 999;"></canvas>
						<video crossOrigin="anonymous" id="vid" :autoplay="false" muted loop @play="go_init" src="https://bikecdn.typhcl.cn/L/j1.mp4" :style="'position: absolute; max-width: 100%; max-height: 100%;'+(vst?'z-index:999;':'z-index:-999;')" :controls="false"></video>
					</div>

					<div style="display: flex;justify-content: space-between;">

						<div style="background: #000;width: 400px;height: 200px;margin-top: 10px;" id="qxt">

						</div>
						<div style="width: 100px;height: 200px;padding-left: 20px;">
							<button :class="'btn '+ (map_name == 'hip' ? 'btn-success' : 'btn-primary')" @click="set_map_name('hip')" style="margin-top: 5px;">髋关节</button>
							<button :class="'btn '+ (map_name == 'knee' ? 'btn-success' : 'btn-primary')" @click="set_map_name('knee')" style="margin-top: 5px;">膝关节</button>
							<button :class="'btn '+ (map_name == 'ankle' ? 'btn-success' : 'btn-primary')" @click="set_map_name('ankle')" style="margin-top: 5px;">踝关节</button>
							<button :class="'btn '+ (map_name == 'elbow' ? 'btn-success' : 'btn-primary')" @click="set_map_name('elbow')" style="margin-top: 5px;">肘关节</button>
							<button :class="'btn '+ (map_name == 'shoulder' ? 'btn-success' : 'btn-primary')" @click="set_map_name('shoulder')" style="margin-top: 5px;">肩关节</button>
							<button :class="'btn '+ (map_name == 'wrist' ? 'btn-success' : 'btn-primary')" @click="set_map_name('wrist')" style="margin-top: 5px;">腕关节</button>

						</div>
					</div>

					<div v-if="ready">
						<button v-if="zt" @click="pause()" class="btn btn-primary" style="margin-top: 10px;margin-right: 10px;">暂停</button>
						<button v-else @click="pause()" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;">继续</button>



						<!-- <button v-if="ddd" @click="ddd=!ddd" class="btn btn-primary" style="margin-top: 20px;margin-right: 10px;">关闭3D</button>
							<button v-else @click="ddd=!ddd" class="btn btn-success" style="margin-top: 20px;margin-right: 10px;">开启3D</button> -->
						<button v-if="jt" @click="jt=!jt" class="btn btn-primary" style="margin-top: 10px;margin-right: 10px;">关闭截图</button>
						<button v-else @click="jt=!jt" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;">开启截图</button>
						<button v-if="!vst" @click="vst=!vst" class="btn btn-primary " style="margin-top: 10px;margin-right: 10px;">实景</button>
						<button v-else @click="vst=!vst" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;">模拟</button>
						<button class="btn btn-success" @click="next_cam" style="margin-top: 10px;margin-right: 10px;" v-if="call==''">切换摄像头</button>
						<button class="btn btn-success" @click="clear" style="margin-top: 10px;margin-right: 10px;">清空</button>

						<button @click="save_fq" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;" v-if="sta==0">保存为Fitting前参数</button>
						<button @click="save_af" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;" v-if="sta==1">保存参数并完成动态评估</button>
					</div>
					<div v-else style="padding: 20px;">
						加载分析模块中，超过一分钟没载入成功请刷新页面
					</div>
				</div>

			</div>
			<div style="flex: 2;padding: 00px 20px;font-size: 16px;max-width: 400px;">


				<div>
					<div style="background: #000;width: 220px;height: 220px;border-radius: 50%;padding:10px;" id="ybt">

					</div>
					<div style="width: 100%;text-align: center;padding: 5px;font-size: 14px;">
						{{fs[map_name]}}平均最大伸展<br>
						{{fs[map_name]}}当前极限伸展:						
						<span v-if="show_max_c=='green'" style="color: #00B83F;">{{show_max}}</span>
						<span v-if="show_max_c=='yellow'" style="color: #ece864;">{{show_max}}</span>
						<span v-if="show_max_c=='red'" style="color: #b41a3f;">{{show_max}}</span><br>
						参考范围：{{dat_line[map_name].u_max}}-{{dat_line[map_name].u_min}}°
					</div>
				</div>

				<div>
					<div style="background: #000;width: 220px;height: 220px;border-radius: 50%;padding:10px;margin-top: 10px;" id="ybt2">

					</div>
					<div style="width: 100%;text-align: center;padding: 5px;font-size: 14px;">
						{{fs[map_name]}}平均最小收缩<br>
						{{fs[map_name]}}当前极限收缩:
						<span v-if="show_min_c=='green'" style="color: #00B83F;">{{show_min}}</span>
						<span v-if="show_min_c=='yellow'" style="color: #ece864;">{{show_min}}</span>
						<span v-if="show_min_c=='red'" style="color: #b41a3f;">{{show_min}}</span><br>
						
						
						参考范围：{{dat_line[map_name].d_max}}-{{dat_line[map_name].d_min}}°
					</div>
				</div>

				<div style="padding: 5px;display: flex;">
					<div v-if="dat[map_name+'_max']['img']!=''">
						<div style="font-size: 14px;text-align: center;">
							{{fs[map_name]}}最大伸展
						</div>
						<div style="max-width: 200px;max-height: 200px;">
							<img @click="show_img(dat[map_name+'_max']['img'])" style="max-width: 200px;max-height: 200px;" :src="dat[map_name+'_max']['img']" />
						</div>
					</div>
					<div v-if="dat[map_name+'_min']['img']!=''">
						<div style="font-size: 14px;text-align: center;">
							{{fs[map_name]}}最小收缩
						</div>
						<div style="max-width: 200px;max-height: 200px;">
							<img @click="show_img(dat[map_name+'_min']['img'])" style="max-width: 200px;max-height: 200px;" :src="dat[map_name+'_min']['img']" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<canvas id="cvs4" style="position: absolute;left: -9999px;top:-9999px"></canvas>
	</div>
</template>

<script>
	import * as poseDetection from '@tensorflow-models/pose-detection';
	import * as tf from '@tensorflow/tfjs-core';
	import '@tensorflow/tfjs-backend-webgl';
	var video = null;
	var canvas1 = null;
	var canvas2 = null;
	var canvas3 = null;
	var canvas4 = null;
	var canvas5 = null;
	var canvas6 = null;
	var ctx1 = null;
	var ctx2 = null;
	var ctx3 = null;
	var ctx4 = null;
	var ctx5 = null;
	var ctx6 = null;
	var detector = null;
	var chartDom = null;
	var myChart = null;
	var ybtdom = null;
	var ybt = null;
	var option_ybt = null;
	var ybtdom2 = null;
	var ybt2 = null;
	var option_ybt2 = null;
	var avg_max = 0;
	var avg_min = 0;


	export default {
		name: 'App',
		data() {
			return {
				is_init:false,//首次开启运行
				show_max: 0,
				show_min: 0,
				show_max_c:"",
				show_min_c:"",
				avg_max: 0,
				avg_min: 0,
				can_fknee: false,
				dat_knee: [
					[0, 0],
					[0, 0]
				],
				allVideoDevices: [],
				cam_index: 0,
				call: "加载中",
				ready: false,
				jt: false,
				ddd: false,
				ck_list: [],
				dsc: "",
				left: "未知",
				id: 0,
				sta: 0,
				map_name: "knee",
				option: {
					series: [{
						data: [10, 22, 28, 23, 19],
						type: 'line',
						smooth: true
					}]
				},
				zt: false,
				vst: true,
				jd: ["knee", "hip", "shoulder", "elbow", "ankle", "wrist"],
				fs: {
					"knee": "膝关节",
					"hip": "髋关节",
					"shoulder": "肩关节",
					"elbow": "肘关节",
					"ankle": "踝关节",
					"wrist": "腕关节"
				},
				dats: {
					"knee": [],
					"hip": [],
					"shoulder": [],
					"elbow": [],
					"ankle": [],
					"wrist": []
				},

				def_dat: {},
				dat_line: {
					"knee": {
						u_max: 148,
						u_max_title: "考虑提高车座5mm并检查脚踏位置",
						u_min: 138,
						u_min_title: "降低车座5mm或检查曲柄长度是否过长",
						d_max: 73,
						d_min: 67 // 更正为与推荐范围一致
					},
					"hip": {
						u_max_title: "车座可能过于后仰",
						u_min_title: "车座可能过于前倾",
						u_max: 105,
						u_min: 90,
						d_max: 70,
						d_min: 55
					},
					"shoulder": {
						u_max_title: "车把可能过低，提高5mm-10mm以增加舒适度",
						u_min_title: "车把可能过高，降低5mm-10mm以获得更好的空气动力学位置",
						u_max: 90,
						u_min: 80,
						d_max: 90,
						d_min: 80
					},
					"elbow": {
						u_max_title: "车把可能过近或过高，调整5mm-10mm以增加伸展",
						u_min_title: "车把可能过远或过低，调整5mm-10mm以减少伸展",
						u_max: 170,
						u_min: 155,
						d_max: 170,
						d_min: 155
					},
					"ankle": {
						u_max_title: "考虑调整骑行姿势",
						u_min_title: "考虑调整骑行姿势",
						u_max: 130,
						u_min: 100,
						d_max: 130,
						d_min: 100
					},
					"wrist": {
						u_max_title: "调整车把倾斜和变速器位置以获得中性位置",
						u_min_title: "确保腕部不过度弯曲，避免压力和拉伤",
						u_max: 170,
						u_min: 150,
						d_max: 170,
						d_min: 150
					}
				},
				foot_index_max: 0,
				dat: {
					see_fx: {
						name: "视角方向",
						val: "未知",
						color: "green"
					},

					fknee_min: {
						name: "膝前量",
						val: "999",
						color: "green"
					},
					knee: {
						name: "膝关节当前角度",
						val: "0",
						color: "green"
					},
					knee_max: {
						name: "膝关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},

					knee_min: {
						name: "膝关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					},
					hip: {
						name: "髋关节当前角度",
						val: "0",
						color: "green"
					},
					hip_max: {
						name: "髋关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},
					hip_min: {
						name: "髋关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					},

					shoulder: {
						name: "肩关节当前角度",
						val: "0",
						color: "green",
						img: ""
					},
					shoulder_max: {
						name: "肩关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},
					shoulder_min: {
						name: "肩关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					},

					elbow: {
						name: "肘关节当前角度",
						val: "0",
						color: "green",
						img: ""
					},
					elbow_max: {
						name: "肘关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},
					elbow_min: {
						name: "肘关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					},

					ankle: {
						name: "踝关节当前角度",
						val: "0",
						color: "green",
						img: ""
					},
					ankle_max: {
						name: "踝关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},
					ankle_min: {
						name: "踝关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					},

					wrist: {
						name: "腕关节当前角度",
						val: "0",
						color: "green",
						img: ""
					},
					wrist_max: {
						name: "腕关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},
					wrist_min: {
						name: "腕关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					}

				}
			};
		},
		created() {
			var that = this
			that.init_mode();
			that.$data.id = this.$route.query.id;
			that.init_dat();
			that.$data.def_dat = JSON.parse(JSON.stringify(that.$data.dat));
		},
		mounted() {
			var that = this
			video = document.getElementsByTagName('video')[0];
			canvas1 = document.getElementById("cvs1");
			canvas2 = document.getElementById("cvs2");
			canvas3 = document.getElementById("cvs3");
			canvas4 = document.getElementById("cvs5");
			canvas5 = document.getElementById("cvs4");
			canvas6 = document.getElementById("cvs6");
			ctx1 = canvas1.getContext("2d");
			ctx2 = canvas2.getContext("2d");
			ctx3 = canvas3.getContext("2d");
			ctx4 = canvas4.getContext("2d");
			ctx5 = canvas5.getContext("2d");
			ctx6 = canvas6.getContext("2d");
			chartDom = document.getElementById('qxt');
			myChart = echarts.init(chartDom);
			var ybt_dom = document.getElementById('ybt');
			ybt = echarts.init(ybt_dom);
			var ybt_dom2 = document.getElementById('ybt2');
			ybt2 = echarts.init(ybt_dom2);
			setInterval(function() {
				that.ref_map()
			}, 1000);




		},
		methods: {
			updateGauge() {


				// {{fs[map_name]}}参考范围
				// <span>最大伸展：{{dat_line[map_name].u_max}}-{{dat_line[map_name].u_min}}°</span>


				var that = this
				const kneeRange = {
					maxExtension: {
						min: that.dat_line[that.map_name].u_min,
						max: that.dat_line[that.map_name].u_max
					}, // 最大伸展范围
					minFlexion: {
						min: that.dat_line[that.map_name].d_min,
						max: that.dat_line[that.map_name].d_max
					}, // 最小收缩范围
				};
				// 将参考范围转换为仪表图上的比例
				const scale = (value, total) => value / total;
				var min = kneeRange.maxExtension.min - 10 // 最小值
				var max = kneeRange.maxExtension.max + 10 // 最大值
				var length = max - min;
				// 设置仪表图的颜色区间
				var colorRanges = [
					[0, '#fd666d'],
					[((kneeRange.maxExtension.min - min - 3) / length), '#fd666d'], // 最大伸展-5度为红色终点

					[((kneeRange.maxExtension.min - min) / length), '#ece864'], // 最大伸展范围为绿色起点

					[((kneeRange.maxExtension.max - min) / length), '#00B83F'], // 最大伸展范围为绿色终点
					[((kneeRange.maxExtension.max - min + 3) / length), '#ece864'], // 最大伸展范围为绿色终点					

					[1, '#fd666d'], // 到180度都为红色
				];


				var option_ybt = {
					series: [{
						animation: true,
						type: 'gauge',
						type: 'gauge',
						min: min, // 最小值
						max: max, // 最大值
						axisLine: {
							lineStyle: {
								width: 4,
								color: colorRanges,
							}
						},
						pointer: {
							itemStyle: {
								color: 'auto'
							}
						},
						axisTick: {
							distance: -30,
							length: 8,
							lineStyle: {
								color: '#fff',
								width: 2
							}
						},
						splitLine: {
							distance: -30,
							length: 30,
							lineStyle: {
								color: '#fff',
								width: 4
							}
						},
						axisLabel: {
							show: false,
							color: 'inherit',
							interval: 1,
							distance: 40,
							fontSize: 12,
							formatter: function(value) {
								// 只显示最小值和最大值的标签

								return value;

							},
						},
						detail: {
							valueAnimation: true,
							formatter: '{value}°',
							color: 'inherit'
						},
						data: [{
							value: avg_max.toFixed(2)
						}]
					}]
				};

				option_ybt && ybt.setOption(option_ybt);


				// 将参考范围转换为仪表图上的比例

				var min = kneeRange.minFlexion.min - 10 // 最小值
				var max = kneeRange.minFlexion.max + 10 // 最大值
				var length = max - min;
				// 设置仪表图的颜色区间
				var colorRanges = [
					[0, '#fd666d'],
					[((kneeRange.minFlexion.min - min - 3) / length), '#fd666d'], // 最大伸展-5度为红色终点

					[((kneeRange.minFlexion.min - min) / length), '#ece864'], // 最大伸展范围为绿色起点

					[((kneeRange.minFlexion.max - min) / length), '#00B83F'], // 最大伸展范围为绿色终点
					[((kneeRange.minFlexion.max - min + 3) / length), '#ece864'], // 最大伸展范围为绿色终点					

					[1, '#fd666d'], // 到180度都为红色
				];


				var option_ybt2 = {
					series: [{
						animation: true,
						type: 'gauge',
						type: 'gauge',
						min: min, // 最小值
						max: max, // 最大值
						axisLine: {
							lineStyle: {
								width: 4,
								color: colorRanges,
							}
						},
						pointer: {
							itemStyle: {
								color: 'auto'
							}
						},
						axisTick: {
							distance: -30,
							length: 8,
							lineStyle: {
								color: '#fff',
								width: 2
							}
						},
						splitLine: {
							distance: -30,
							length: 30,
							lineStyle: {
								color: '#fff',
								width: 4
							}
						},
						axisLabel: {
							show: false,
							color: 'inherit',
							interval: 1,
							distance: 40,
							fontSize: 12,
							formatter: function(value) {
								// 只显示最小值和最大值的标签

								return value;

							},
						},
						detail: {
							valueAnimation: true,
							formatter: '{value}°',
							color: 'inherit'
						},
						data: [{
							value: avg_min.toFixed(2)
						}]
					}]
				};

				option_ybt2 && ybt2.setOption(option_ybt2);
			},
			save_af() {
				var that = this
				if (confirm("确认结束动态评估？")) {
					$.ajax({
						url: that.URL,
						method: "POST",
						data: {
							t: "save_af",
							token: localStorage.getItem('token'),
							id: that.$data.id,
							bf_dat: JSON.stringify(that.$data.dat),
							fx: that.$data.dat.see_fx.val,
							bf_img: canvas5.toDataURL(),
							wd1: canvas2.toDataURL(),
							wd2: canvas3.toDataURL(),
							wd3: canvas6.toDataURL(),

						},
						dataType: "json",
						success(e) {
							that.jref_r('/finish?id=' + that.$data.id);
						}
					})
				}

			},
			save_fq() {
				var that = this
				$.ajax({
					url: that.URL,
					method: "POST",
					data: {
						t: "save_fq",
						token: localStorage.getItem('token'),
						id: that.$data.id,
						bf_dat: JSON.stringify(that.$data.dat),
						fx: that.$data.dat.see_fx.val,
						bf_img: canvas5.toDataURL(),
						wd1: canvas2.toDataURL(),
						wd2: canvas3.toDataURL(),
						wd3: canvas6.toDataURL(),

					},
					dataType: "json",
					success(e) {
						that.$data.sta = 1;
					}
				})
			},

			init_dat() {
				var that = this
				// $.ajax({
				// 	url: that.URL,
				// 	data: {
				// 		t: "fitting_init",
				// 		token: localStorage.getItem('token'),
				// 		id: that.$data.id,
				// 	},
				// 	dataType: "json",
				// 	success(e) {
				// 		if (e.pid == 0) {
				// 			that.$router.replace('/login');
				// 		}
				// 		that.$data.ck_list = e.list;
				// 		//console.log(that.$data.ck_list);
				// 	}
				// })
			},
			wd_clean() {
				var that = this
				ctx2.clearRect(0, 0, canvas4.width, canvas4.height);
				ctx3.clearRect(0, 0, canvas3.width, canvas3.height);
				ctx6.clearRect(0, 0, canvas6.width, canvas6.height);
			},
			set_map_name(name) {
				this.$data.map_name = name;
			},
			calculatePeakValleyAverages(data, threshold) {

				let peaks = [];
				let valleys = [];
				let previous = data[0];

				// 平滑数据

				var smoothed = data;
				for (let i = 1; i < smoothed.length - 1; i++) {
					if (smoothed[i] > smoothed[i - 1] && smoothed[i] > smoothed[i + 1] && smoothed[i] - previous > threshold) {
						peaks.push({
							value: smoothed[i],
							index: i
						});
						previous = smoothed[i];
					} else if (smoothed[i] < smoothed[i - 1] && smoothed[i] < smoothed[i + 1] && previous - smoothed[i] > threshold) {
						valleys.push({
							value: smoothed[i],
							index: i
						});
						previous = smoothed[i];
					}
				}

				// 去除第一组和最后一组波峰波谷
				if (peaks.length > 2 && valleys.length > 2) {
					peaks = peaks.slice(1, -1);
					valleys = valleys.slice(1, -1);
				}

				// 提取值用于排序和计算
				peaks = peaks.map(p => p.value).sort((a, b) => a - b);
				valleys = valleys.map(v => v.value).sort((a, b) => a - b);

				// 去除最大值和最小值，如果数组长度允许
				if (peaks.length > 4) {
					peaks = peaks.slice(2, -2);
				}
				if (valleys.length > 4) {
					valleys = valleys.slice(2, -2);
				}
				var actual_max = Math.max(...data);
				
				var actual_min = Math.min(...data);
				// 计算平均值
				avg_max = peaks.length ? peaks.reduce((a, b) => a + b, 0) / peaks.length : 0;
				avg_min = valleys.length ? valleys.reduce((a, b) => a + b, 0) / valleys.length : 0;

				return {
					avg_max,
					avg_min,
					actual_max,
					actual_min
				};
			},
			ref_map() {
				var that = this;
				var data = that.$data.dats[that.$data.map_name];
				if (data.length > 100) {
					data = data.slice(-100);
				}
				// var data = that.$data.dats[that.$data.map_name];
				// Here you might want to preprocess your data to fit the effective area criteria

				var threshold = (that.$data.dat[that.$data.map_name + '_max'].val - that.$data.dat[that.$data.map_name + '_min'].val) / 8
				//threshold=5;
				var recall = that.calculatePeakValleyAverages(data, threshold);
				
				var avg_max=recall.avg_max;
				var avg_min=recall.avg_min;
				var show_max=recall.actual_max;
				var show_min=recall.actual_min;
				that.show_max = show_max;
				that.show_min = show_min;
				that.show_max_c=that.updateColor(that.show_max,that.dat_line[that.map_name])
				that.show_min_c=that.updateColor(that.show_min,that.dat_line[that.map_name])
				
				// 使用 avg_max 和 avg_min
				that.avg_max = avg_max;
				that.avg_min = avg_min;

				// Now you have your avg_max and avg_min, which you can use as needed
				that.avg_max = avg_max.toFixed(2);
				that.avg_min = avg_min.toFixed(2);
				const range = that.$data.dat_line[that.$data.map_name];
				let statusNormal = true;
				let statusMessage = "状态正常";
				let isHigh = false;
				const countInNormalRange = data.filter(point => (point >= range.u_min && point <= range.u_max) || (point >= range.d_min && point <= range.d_max)).length;
				const percentageInNormalRange = countInNormalRange / data.length;
				// 根据比例决定是否提示异常
				//console.log(countInNormalRange)
				if (percentageInNormalRange < 0.8) {
					// Check if any point is too high or too low
					for (let i = 0; i < data.length; i++) {
						if (data[i] > range.u_max) {
							statusNormal = false;
							statusMessage = range.u_min_title;
							isHigh = true;
							break; // High condition takes precedence
						} else if (data[i] < range.u_min) {
							statusNormal = false;

							statusMessage = range.u_max_title;
							// Do not break here to ensure high condition can override if it occurs
						}
					}

					// If there's a high condition, no need to check for low condition further
					if (!isHigh && typeof(range.d_max_title) != 'undefined') {
						for (let i = 0; i < data.length; i++) {
							if (data[i] < range.d_min) {
								statusNormal = false;
								statusMessage = range.d_max_title;
								break; // Once a low condition is found, no need to check further
							} else if (data[i] > range.d_max) {
								statusNormal = false;

								statusMessage = range.d_min_title;
								break; // Once a high condition is found in the second set, stop checking
							}
						}
					}
				}
				//console.log(range)
				if (statusMessage == "") {
					statusMessage = "状态正常";
				}
				// Set the description based on the analysis
				that.$data.dsc = statusMessage;


				var dataLength = data.length;
				var requiredLength = 100;
				if (dataLength < requiredLength) {
					var padding = new Array(requiredLength - dataLength).fill(90);
					data = padding.concat(data);
				}

				// 获取当前关节的推荐范围

				// 计算最大值和最小值
				const dataMax = Math.max(...data);
				const dataMin = Math.min(...data);

				// 设置y轴范围
				// 假设range对象包含u_min, u_max, d_min, 和d_max作为参考线的值
				const referenceLines = [range.u_min, range.u_max, range.d_min, range.d_max];

				// 找到包括所有参考线在内的最大值和最小值
				const adjustedMax = Math.max(dataMax, ...referenceLines);
				const adjustedMin = Math.min(dataMin, ...referenceLines);
				//console.log(adjustedMax,adjustedMin)
				// 设置y轴范围，同时确保所有参考线在范围内
				var yAxisMax = adjustedMax + 10; // 为最大值留出一定的空间
				var yAxisMin = adjustedMin - 10 < 0 ? 0 : adjustedMin - 10; // 为最小值留出一定的空间，且不小于0

				// 用这个新的yAxisMin和yAxisMax来配置你的图表



				var option = {
					animation: false,
					// grid: {
					//         left: '10%', // 留出足够的空间显示Y轴标签
					//         right: '10%',
					//         top: '10%',
					//         bottom: '10%',
					//         containLabel: true
					//     },
					grid: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0,
						containLabel: false
					},
					xAxis: {
						type: 'category',
						data: [],
						show: false,
					},
					// yAxis: {
					//         type: 'value',
					//         show: true, // 显示Y轴
					//         axisLabel: {
					//             show: true, // 显示Y轴标签
					//             formatter: '{value}', // Y轴标签的格式
					//         },
					//         axisTick: {
					//             show: true, // 显示Y轴刻度
					//         },
					//         splitLine: {
					//             show: true, // 显示网格线
					//         },
					// 	 interval:5, // 设置Y轴刻度的间隔为1
					//     },
					yAxis: {
						type: 'value',
						show: false,
						min: yAxisMin,
						max: yAxisMax
					},
					series: [{
						data: data,
						type: 'line',
						smooth: true,
						itemStyle: {
							color: 'green'
						},
						showSymbol: false,
						lineStyle: {
							width: 2
						},
						markLine: {
							silent: true, // 参考线不响应鼠标事件
							symbol: ['none', 'none'], // 不显示标记线的两端符号，即没有箭头
							data: [{
									yAxis: range.u_min,
									lineStyle: {
										color: '#fff',
										type: 'dashed'
									}
								},
								{
									yAxis: range.u_max,
									lineStyle: {
										color: '#fff',
										type: 'dashed'
									}
								},
							]
						}
					}],
					splitLine: {
						show: true,
						lineStyle: {
							color: '#fff',
							type: 'solid'
						}
					}
				};

				// 如果存在第二组范围，则添加额外的标记线
				if (range.d_min !== undefined && range.d_max !== undefined) {
					option.series[0].markLine.data.push({
						yAxis: range.d_min,
						lineStyle: {
							color: '#fff',
							type: 'dashed'
						}
					}, {
						yAxis: range.d_max,
						lineStyle: {
							color: '#fff',
							type: 'dashed'
						}
					});
				}

				option && myChart.setOption(option);
				that.updateGauge();

			},
			pause() {
				var that = this
				if (!that.$data.zt) {
					setTimeout(function() {
						that.can_fknee = true;
					}, 1000)
					video.play();
				} else {
					video.pause();
				}
				that.$data.zt = !that.$data.zt;
			},
			go_init() {
				var that = this
				//console.log("onplay");
				if (that.ready) {
					setTimeout(function() {
						that.set_cam_v();
						that.startPoseDetection();
					}, 3000)
				} else {
					setTimeout(function() {
						that.go_init();

					}, 2000)
				}

				//that.startPoseDetection();
			},
			async next_cam() {
				var that = this
				//cam_index

				if (that.$data.cam_index == (that.$data.allVideoDevices.length) - 1) {
					that.$data.cam_index = 0;
				} else {
					that.$data.cam_index++;
				}
				//console.log(that.$data.allVideoDevices);
				try {
					const stream = await navigator.mediaDevices.getUserMedia({
						video: {
							deviceId: {
								exact: that.$data.allVideoDevices[that.$data.cam_index].deviceId
							}
						}
					});

					const videoTrack = stream.getVideoTracks()[0];
					//console.log(stream.getVideoTracks);
					const settings = videoTrack.getSettings();
					that.set_cam_v(settings.width, settings.height);

					var video = document.getElementsByTagName("video")[0];
					video.srcObject = stream;
					video.play();
				} catch (error) {
					console.error('Error switching cameras:', error);
					this.call = error;
				}
			},
			clear() {
				var that = this
				//console.log()
				that.foot_index_max = 0;
				that.can_fknee = false;
				if (!that.$data.zt) {


				} else {
					setTimeout(function() {
						that.can_fknee = true;
					}, 1000)
				}
				that.$data.dat = JSON.parse(JSON.stringify(that.$data.def_dat));;
				that.$data.dats = {
					"knee": [],
					"hip": [],
					"shoulder": [],
					"elbow": [],
					"ankle": [],
					"wrist": []
				};
			},
			set_cam_v() {
				var that = this

				var vh = video.videoHeight;
				var vw = video.videoWidth;
				console.log(vw, vh)
				console.log(video.offsetWidth, video.offsetHeight)
				canvas5.width = video.offsetWidth;
				canvas5.height = video.offsetHeight;
				canvas4.width = video.offsetWidth;
				canvas4.height = video.offsetHeight;
				canvas1.width = video.offsetWidth / 3;
				canvas1.height = video.offsetHeight / 3;
				canvas6.width = video.offsetWidth / 3;
				canvas6.height = video.offsetHeight / 3;
				canvas2.width = video.offsetWidth / 3;
				canvas2.height = video.offsetHeight / 3;
				canvas3.width = video.offsetWidth / 3;
				canvas3.height = video.offsetHeight / 3;
			},
			async initCamera() {
				var that = this
				try {
					video.addEventListener('loadedmetadata', function() {
						//console.log("重新载入尺寸")

					});
					const stream = await navigator.mediaDevices.getUserMedia({
						video: true
					});
					const videoTrack = stream.getVideoTracks()[0];
					const settings = videoTrack.getSettings();
					video.srcObject = stream;
					that.$data.call = ""
					video.play();

					try {
						const devices = await navigator.mediaDevices.enumerateDevices();
						that.$data.allVideoDevices = devices.filter(device => device.kind === 'videoinput');
					} catch (error) {
						console.error('Error listing cameras:', error);
						that.$data.call = "未发现可用摄像头，进入演示模式，尝试刷新"

					}
					that.stas = 1;
				} catch (error) {
					//console.log(error);
					that.$data.call = "未发现可用摄像头，进入演示模式，尝试刷新"
					// uni.showModal({
					// 	title: '温馨提示',
					// 	content: '实时分析依赖设备镜头权限，请授权。',
					// 	success: function(res) {
					// 		if (res.confirm) {
					// 			that.initCamera();
					// 		} else if (res.cancel) {
					// 			wx.miniProgram.navigateBack()
					// 		}
					// 	}
					// })
				}


			},


			captureCurrentFrame() {
				// 获取现有的两个Canvas元素
				var canvas1 = document.getElementsByTagName('canvas')[0];
				var canvas2 = document.getElementsByTagName('canvas')[1];

				// 创建一个新的Canvas元素
				var mergedCanvas = document.createElement('canvas');
				var ctx = mergedCanvas.getContext('2d');

				// 设置新Canvas的大小以容纳两个Canvas的内容
				var vl = 1 / uni.getSystemInfoSync().pixelRatio;

				mergedCanvas.width = Math.max(canvas1.width, canvas2.width) * vl;
				mergedCanvas.height = Math.max(canvas1.height, canvas2.height) * vl;


				// 在新Canvas上绘制两个现有Canvas的内容
				ctx.scale(vl, vl);
				ctx.drawImage(canvas2, 0, 0);
				ctx.drawImage(canvas1, 0, 0);

				// 将新Canvas转换为Base64编码的图片
				return mergedCanvas.toDataURL('image/png');
			},
			updateAngleAndCaptureImage(jointName, newAngle) { //更新关节
				var that = this
				if (typeof(that.img_list[jointName]) == 'undefined') {
					that.img_list[jointName] = {
						maxAngle: 0,
						minAngle: 360,
						maxImage: '',
						minImage: ''
					}
				}
				var newAngle = parseFloat(newAngle);


				if (newAngle > that.img_list[jointName].maxAngle) {

					that.img_list[jointName].maxAngle = newAngle;
					that.img_list[jointName].maxImage = that.captureCurrentFrame();
				}

				if (newAngle < that.img_list[jointName].minAngle) {
					that.img_list[jointName].minAngle = newAngle;
					that.img_list[jointName].minImage = that.captureCurrentFrame();
				}
			},
			async init_mode() {

				await tf.setBackend('webgl');
				await tf.ready();

				const detectorConfig = {
					landmarkModelUrl: 'https://bikecdn.typhcl.cn/model1/land/model.json',
					detectorModelUrl: "https://bikecdn.typhcl.cn/model1/dPose/model.json",
					runtime: 'tfjs',
					enableSmoothing: true,
					modelType: 'heavy'
				};
				// const detectorConfig = {
				// 	landmarkModelUrl: 'https://bikecdn.typhcl.cn/bike/static/land/model.json',
				// 	detectorModelUrl: "https://bikecdn.typhcl.cn/bike/static/dPose/model.json",
				// 	runtime: 'tfjs',
				// 	enableSmoothing: true,
				// 	modelType: 'full'
				// };
				detector = await poseDetection.createDetector(poseDetection.SupportedModels.BlazePose, detectorConfig);
				this.sta = "";
				//console.log("初始化成功")
				this.$data.ready = true;

				this.initCamera();


			},
			updateColor(value, range) {
				if (value >= range.u_min && value <= range.u_max || (range.d_min !== undefined && value >= range.d_min && value <= range.d_max)) {
					return "green"; // 在推荐范围内
				} else if ((value >= range.u_min - 3 && value < range.u_min) || (value <= range.u_max + 3 && value > range.u_max) || (range.d_min !== undefined && ((value >= range.d_min - 3 && value < range.d_min) || (value <= range.d_max + 3 && value > range.d_max)))) {
					return "yellow"; // 在推荐范围的±3度内
				} else {
					return "red"; // 不在推荐范围内
				}
			},

			u_avg(name, avg) {
				var that = this
				avg = parseFloat(avg);

				// 获取当前关节的推荐范围
				const range = that.$data.dat_line[name];

				if (!range) return; // 如果没有找到对应关节的范围，则直接返回

				let color = "red"; // 默认设置为红色

				// 检查第一组范围
				if (avg >= range.u_min && avg <= range.u_max) {
					color = "green"; // 在推荐范围内
				} else if ((avg >= range.u_min - 3 && avg < range.u_min) || (avg <= range.u_max + 3 && avg > range.u_max)) {
					color = "yellow"; // 在推荐范围的±3度内
				}

				// 如果存在第二组范围，也进行检查
				if (range.d_min !== undefined && range.d_max !== undefined) {
					if (avg >= range.d_min && avg <= range.d_max) {
						color = "green"; // 在第二组推荐范围内
					} else if ((avg >= range.d_min - 3 && avg < range.d_min) || (avg <= range.d_max + 3 && avg > range.d_max)) {
						color = color === "green" ? "green" : "yellow"; // 如果已经是绿色，则保持不变，否则设为黄色
					}
				}

				// 更新颜色和角度值
				that.$data.dat[name].color = color;
				that.$data.dat[name].val = avg.toFixed(1);

				// 更新角度数据数组
				if (that.$data.dats[name].length == 0 || that.$data.dats[name][that.$data.dats[name].length - 1] != avg) {
					that.$data.dats[name].push(avg);
				}

				that.$data.dat[name].val = parseFloat(avg).toFixed(1);
				if (that.$data.dat[name + "_min"].val > avg || that.$data.dat[name + "_min"].val == "0") {
					that.$data.dat[name + "_min"].val = parseFloat(avg).toFixed(1);
					that.$data.dat[name + "_min"].color = that.updateColor(parseFloat(avg).toFixed(1), range)
					if (that.$data.jt) {
						that.$data.dat[name + "_min"].img = canvas5.toDataURL("image/png");
					}
				}
				if (that.$data.dat[name + "_max"].val < avg || that.$data.dat[name + "_max"].val == "0") {
					that.$data.dat[name + "_max"].val = parseFloat(avg).toFixed(1);
					that.$data.dat[name + "_max"].color = that.updateColor(parseFloat(avg).toFixed(1), range)
					if (that.$data.jt) {
						that.$data.dat[name + "_max"].img = canvas5.toDataURL("image/png");
					}
				}

				// var sum=0;
				// for(var i in that.$data.dats[name]){
				// 	sum+=parseFloat(that.$data.dats[name][i])
				// }				
				// that.$data.dat[name+"_avg"].val=(sum/that.$data.dats[name].length).toFixed(1);

			},
			updateknee_x(newAngles, showLeftSide) { //更新关节
				var that = this
				if (!that.can_fknee) {
					console.log("拦截更新")
					return 0;
				}
				if (newAngles[0][0] == 0 || newAngles[0][0] == 0) {
					return 0;
				}
				// if ((that.$data.foot_index_max < newAngles[0][0]) || that.$data.foot_index_max == 0 || that.dat.fknee_min.val == 999) {
				// 	that.$data.foot_index_max = newAngles[0][0];
				// } else {
				// 	return 0;
				// }

				if (showLeftSide) {
					var val = parseFloat(newAngles[1][0] - newAngles[0][0]).toFixed(1);
					if ((that.dat.fknee_min.val > val) || parseInt(that.dat.fknee_min.val) == 0) {

						that.dat.fknee_min.val = val

						if (that.dat.fknee_min.val < -30) {
							that.dat.fknee_min.color = "red";
						} else {
							if (that.dat.fknee_min.val < 0) {
								that.dat.fknee_min.color = "yellow";
							} else {
								that.dat.fknee_min.color = "green";
							}

						}
					}
				} else {
					var val = (newAngles[0][0] - newAngles[1][0]).toFixed(1);

					// if ((that.dat.fknee_min.val > that.dat.fknee.val) || that.dat.fknee_min.val == "0") {
					// 	that.dat.fknee_min.val = that.dat.fknee.val
					// }
					if ((that.dat.fknee_min.val > val) || parseInt(that.dat.fknee_min.val) == 0) {

						that.dat.fknee_min.val = val

						if (that.dat.fknee_min.val < -30) {
							that.dat.fknee_min.color = "red";
						} else {
							if (that.dat.fknee_min.val < 0) {
								that.dat.fknee_min.color = "yellow";
							} else {
								that.dat.fknee_min.color = "green";
							}

						}
					}
				}



			},

			calculateAngle(pt1, pt2, pt3) {
				if (this.$data.ddd) {
					// 计算三维空间中的边长
					const a = Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2) + Math.pow(pt2.z - pt1.z, 2));
					const b = Math.sqrt(Math.pow(pt2.x - pt3.x, 2) + Math.pow(pt2.y - pt3.y, 2) + Math.pow(pt2.z - pt3.z, 2));
					const c = Math.sqrt(Math.pow(pt3.x - pt1.x, 2) + Math.pow(pt3.y - pt1.y, 2) + Math.pow(pt3.z - pt1.z, 2));

					// 使用余弦定律计算角度
					const cosTheta = (a * a + b * b - c * c) / (2 * a * b);
					const angle = Math.acos(cosTheta) * (180 / Math.PI); // 转换为度
					return angle.toFixed(2);
				} else {
					const a = Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
					const b = Math.sqrt(Math.pow(pt2.x - pt3.x, 2) + Math.pow(pt2.y - pt3.y, 2));
					const c = Math.sqrt(Math.pow(pt3.x - pt1.x, 2) + Math.pow(pt3.y - pt1.y, 2));
					const angle = Math.acos((a * a + b * b - c * c) / (2 * a * b));
					var dat = angle * (180 / Math.PI);
					return dat.toFixed(2);
				}

			},
			async startPoseDetection() {
				var that = this


				var vl = 1;
				const poseDetectionLoop = async () => {

					ctx5.drawImage(video, 0, 0, video.offsetWidth, video.offsetHeight);
					//ctx4.drawImage(video, 0, 0, video.offsetWidth, video.offsetHeight);
					const estimationConfig = {
						flipHorizontal: false
					};
					// //console.log(video);
					var videos = document.getElementById("vid");
					const poses = await detector.estimatePoses(canvas5, estimationConfig);
					if(!that.is_init){
						that.is_init=true;
						that.vst=false;
					}
					poses.forEach(pose => {
						if (!that.$data.zt) {
							return 0;
						}
						ctx4.clearRect(0, 0, canvas4.width, canvas4.height);
						if (!that.$data.vst) {
							ctx4.fillStyle = '#000000';
							ctx4.fillRect(0, 0, canvas4.width, canvas4.height);
						}
						if (pose.score > 0.95) {

							const head = pose.keypoints.find(k => k.name === 'nose');
							// Assuming you have separate keypoints for left and right hips
							const leftHip = pose.keypoints.find(k => k.name === 'left_hip');
							const rightHip = pose.keypoints.find(k => k.name === 'right_hip');

							if (head && leftHip && rightHip) {


								const showLeftSide = head.x < (leftHip.x + rightHip.x) / 2;
								that.$data.dat.see_fx.val = showLeftSide ? '左侧' : '右侧';


								pose.keypoints.forEach(({
									x,
									y,
									name
								}) => {
									x = x * vl.toFixed(2);
									y = y * vl.toFixed(2);
									var side_list = ["knee", "hip", "ankle", "shoulder", "elbow", "wrist"];
									for (var ix in side_list) {
										if (name.includes(showLeftSide ? 'left_' + side_list[ix] : 'right_' + side_list[ix])) {
											const leftHipX = x; // x坐标
											const leftHipY = y; // y坐标
											ctx4.beginPath(); // 开始新路径
											ctx4.arc(leftHipX, leftHipY, 8, 0, 2 * Math.PI); // 绘制圆：圆心x, 圆心y, 半径, 起始角度, 结束角度
											
											if(that.map_name==side_list[ix]){
												ctx4.fillStyle = '#ef0006'; // 设置填充颜色
												ctx4.fill(); // 填充圆
												ctx4.strokeStyle = '#ef0006'; // 设置边框颜色
											}else{
												ctx4.fillStyle = '#0e00f1'; // 设置填充颜色
												ctx4.fill(); // 填充圆
												ctx4.strokeStyle = '#0e00f1'; // 设置边框颜色
											}
											
											ctx4.lineWidth = 2; // 设置线宽
											ctx4.stroke(); // 绘制圆的边框										
										}
									}
									if (name.includes(showLeftSide ? 'left_hip' : 'right_hip')) {


										ctx6.beginPath();
										ctx6.arc(x / 3, y / 3, 1, 0, 1 * Math.PI);
										ctx6.fillStyle = 'green';
										ctx6.fill();

									}
									if (name.includes(showLeftSide ? 'left_ankle' : 'right_ankle')) {

										ctx2.beginPath();
										ctx2.arc(x / 3, y / 3, 1, 0, 1 * Math.PI);
										ctx2.fillStyle = 'green';
										ctx2.fill();
									}
									if (name.includes(showLeftSide ? 'left_knee' : 'right_knee')) {
										ctx3.beginPath();
										ctx3.arc(x / 3, y / 3, 1, 0, 1 * Math.PI);
										ctx3.fillStyle = 'green';
										ctx3.fill();
									}
									if (name.includes(showLeftSide ? 'left_knee' : 'right_knee')) {
										const leftHipX = x;
										const leftHipY = y;
										ctx4.beginPath();
										ctx4.arc(x, y, 1, 0, 1 * Math.PI);
										ctx4.fillStyle = 'green';
										ctx4.fill();

										that.dat_knee[0] = [leftHipX, leftHipY] //膝盖

									}
									if (name.includes(showLeftSide ? 'left_foot_index' : 'right_foot_index')) {
										const leftHipX = x;
										const leftHipY = y;
										that.dat_knee[1] = [leftHipX, leftHipY] //脚尖
										if (showLeftSide) {
											//左侧

											if (that.foot_index_max < leftHipX || that.foot_index_max == 0) {
												that.foot_index_max = leftHipX;

												that.updateknee_x(that.dat_knee, showLeftSide);
											}


										} else {
											if (that.foot_index_max > leftHipX || that.foot_index_max == 0) {
												that.foot_index_max = leftHipX;
												that.updateknee_x(that.dat_knee, showLeftSide);
											}
										}



									}

									ctx4.strokeStyle = 'blue';
									ctx4.lineWidth = 2;
									var limbs = showLeftSide ? [
										// 左侧
										['left_shoulder', 'left_hip', 'left_knee'], // 髋关节角度
										['left_hip', 'left_knee', 'left_ankle'], // 膝关节角度
										['left_knee', 'left_ankle',
											'left_foot_index'
										], // 踝关节角度
										['left_elbow', 'left_shoulder', 'left_hip'], // 肩关节角度
										['left_shoulder', 'left_elbow', 'left_wrist'], // 肘关节角度
										['left_index', 'left_wrist', 'left_elbow'], // 腕关节角度
									] : [
										['right_shoulder', 'right_hip', 'right_knee'], // 髋关节角度
										['right_hip', 'right_knee', 'right_ankle'], // 膝关节角度
										['right_knee', 'right_ankle',
											'right_foot_index'
										], // 踝关节角度
										['right_elbow', 'right_shoulder', 'right_hip'], // 肩关节角度
										['right_shoulder', 'right_elbow', 'right_wrist'], // 肘关节角度
										['right_index', 'right_wrist', 'right_elbow'], // 腕关节角度
									];

									limbs.forEach(limb => {
										if (limb.length === 3) {

											const [startPart, middlePart, endPart] = limb;
											var names = middlePart.split("_")[1];
											const startKeypoint = pose.keypoints.find(k =>
												k
												.name ===
												startPart);
											const middleKeypoint = pose.keypoints.find(k =>
												k
												.name ===
												middlePart);
											const endKeypoint = pose.keypoints.find(k => k
												.name ===
												endPart);

											if (startKeypoint && middleKeypoint && endKeypoint) {
												// 计算角度
												const angle = that.calculateAngle(startKeypoint, middleKeypoint, endKeypoint);
												if (side_list.includes(names)) {

													that.u_avg(names, angle);


												}
												ctx4.beginPath();
												ctx4.moveTo(startKeypoint.x * vl, startKeypoint.y * vl);
												ctx4.lineTo(middleKeypoint.x * vl, middleKeypoint.y * vl);
												ctx4.lineTo(endKeypoint.x * vl, endKeypoint.y * vl);
												ctx4.strokeStyle = '#1db415';
												ctx4.lineWidth = 4;
												ctx4.stroke();

											}
										}
									});


								});


							}
						}

					});

					requestAnimationFrame(poseDetectionLoop);
				};

				poseDetectionLoop();





			}
		}
		// 可能的计算属性和方法...
	};
</script>

<style>
	.green {
		color: #00B83F;
	}

	.yellow {
		color: #ece864;
	}

	.red {
		color: #b41a3f;
	}
</style>